import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";

/**
 * Кэшированный каталог 40 приёмов Альтшуллера для tooltip'ов.
 * Кэш живёт 1 час — приёмы не меняются между прогонами.
 */
export function usePrinciples() {
  return useQuery({
    queryKey: ["principles"],
    queryFn: () => api.principles(),
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
}
